import React from "react"

import "./Icon.scss"

export const IconLocked: React.FC = () => <div className="neo__iconLocked" />
export const IconUnlocked: React.FC = () => <div className="neo__iconUnlocked" />
export const IconInfo: React.FC = () => <div className="neo__iconInfo">i</div>
